export default __webpack_public_path__ + "static/media/IMG_20190723_161141.beed3a94.jpg";